





















































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';

@Component({})
export default class Edit extends BaseFormEdit {
  form = {
    code: '',
    description: '',
    name: ''
  } as any;
}
